module.exports = __webpack_public_path__ + "img/39.abf45c9f.png";